<template>
	<div class="">
		<div class="centerWidth " :style="{ 'display': isTab == 2 ? 'none' : '' }">
			<section class="xtianbao_h1 ">
				<div class="my-title">一键智能填报</div>
			</section>
		</div>
		<div>
			<!-- 基本信息 -->
			<!-- <one-page v-if="isTab == 0"></one-page> -->
			<!-- 意向选择 -->
			<!-- <two-page v-else-if="isTab == 1"></two-page> -->
			<!-- 精确选择 -->
			<!-- <three-page v-else-if="isTab == 2"></three-page> -->
			<!-- 生成志愿表 -->
			<!-- <four-page v-else-if="isTab == 3"></four-page> -->
			<keep-alive include="three-page" :max="20">
				<component :is="cmpName" :key="selectId"></component>
			</keep-alive>
		</div>
	</div>
</template>

<script>
	import onePage from './tianBaoA.vue';
	import twoPage from './tianBaoB.vue';
	import threePage from './tianBaoC.vue';
	import fourPage from './tianBaoD.vue';
	export default {
		components: {
			onePage,
			twoPage,
			threePage,
			fourPage
		},
		data() {
			return {
				// 阶段一填写的总分
				totalScore: 0,
				oldSelectId: -1,
				selectId: 0,
				isTab: 0,
				firstId: 0, // 第一步的数据Id
				// 阶段三选择的院校志愿
				// selectedCollegeMajor: [],
				// 阶段三选择的志愿id
				// majorId: [],
				cmpNameArr: ['one-page', 'two-page', 'three-page', 'four-page'],
				selectType: 0, // 选择的高校类型 1本科 2专科
				key: ''
			};
		},
		watch: {
			isTab() {
				this.scrollTop();
			},
			selectId(newVal, oldVal) {
				this.oldSelectId = oldVal;
			}
		},
		computed: {
			cmpName() {
				return this.cmpNameArr[this.isTab] || 'one-page';
			}
		},
		created() {
			if (this.$route.query) {
				this.$route.query.vId && (this.firstId = Number(this.$route.query.vId));
				this.selectType = this.$route.query.type ? Number(this.$route.query.type) : 0;
			}
		},
		methods: {
			setTotalScore(val) {
				this.totalScore = val;
			},
			// 设置majorId
			// setMajorId(val) {
			//     this.majorId = this.$util.clone(val);
			// },
			// 设置selectedCollegeMajor
			// setSelectedCollegeMajor(val) {
			//     this.selectedCollegeMajor = this.$util.clone(val);
			// },
			scrollTop() {
				document.querySelector('body').scrollTo(0, 0);
				window.scrollTo(0, 0);
			},
			setNext: function(step, saveId) {
				var that = this;
				if (step === 1) {
					that.isTab = step;
					that.firstId = saveId > 0 ? saveId : that.saveId;
				}
				document.querySelector('body').scrollTo(0, 0);
				window.scrollTo(0, 0);
			},
			goNext(id) {
				this.isTab = id;
				document.querySelector('body').scrollTo(0, 0);
				window.scrollTo(0, 0);
			}
		}
	};
</script>

<style scoped>
	/* gaokao-content */
	.xtianbao_h1 {
		padding: 0 20px;
		width: 100%;
		margin: 20px 0 0 0;
		height: auto;
		overflow: hidden;
		background-color: #fff;
	}
</style>
